import React from "react";
import { Grid } from "@mui/material";

export default function SectionHalfItemContainer({
  children,
}: {
  children: React.ReactNode;
}): React.JSX.Element {
  return (
    <Grid
      className="scd-container-base"
      container
      size={{ xs: 12, md: 8, lg: 6 }}
    >
      {children}
    </Grid>
  );
}
